import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Cta = () => {
  const navigate = useNavigate();
  const { trackAction } = useAnalytics({ component: "Cta" });
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const handleGetStarted = () => {
    // Track the click action
    trackAction("cta_get_started_click");
    
    // Get UTM parameters from URL
    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    
    // Build the navigation URL with UTM parameters
    const authUrl = new URL("/auth", window.location.origin);
    authUrl.searchParams.append("tab", "signup");
    
    // Only add UTM parameters if they exist
    if (utm_source) authUrl.searchParams.append("utm_source", utm_source);
    if (utm_medium) authUrl.searchParams.append("utm_medium", utm_medium);
    if (utm_campaign) authUrl.searchParams.append("utm_campaign", utm_campaign);
    
    navigate(authUrl.pathname + authUrl.search);
  };

  return (
    <section className="py-24 bg-gradient-to-r from-gebeya-pink to-gebeya-orange">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-xl opacity-90 mb-10">
            {t('cta.subtitle')}
          </p>
          <Button 
            size="lg" 
            variant="secondary" 
            className="bg-white text-gebeya-pink hover:bg-gray-100"
            onClick={handleGetStarted}
          >
            {t('cta.getStartedNow')}
          </Button>
        </div>
      </div>
    </section>
  );
};
